export const tableCols = [
  "Full Name",
  "Rank",
  "Email Id",
  "Co2 Emissions",
  "Co2 Saved",
  //"Carbon Credits",
];
